<template>
  <el-form
      ref="form" :model="form">
    <template>
      <div style="margin-bottom: 10px;" v-if="addOpType">
        <gj-button type="primary" @click="addProduct">添加产品
        </gj-button>
        <gj-button @click="importProduct">导入产品
        </gj-button>
        <gj-button type="text" @click="deleteProduct(selectedRows)">移除
        </gj-button>
      </div>
    </template>
    <gj-table
        ref="gjTable"
        selection
        :index="false"
        name="purchasePlanAddProduct"
        :data="form.items"
        :columns="columns"
        :min-height="226"
        border
        :offset-height="offsetHeight">
      <template v-slot:header:planDate>
        计划交期
        <el-popover placement="bottom" width="160">
          <div style="font-size: 12px;color:#333333;margin-top: -5px; padding-bottom:10px;margin-left: 5px;">
            <span>计划交期</span>
          </div>
          <gj-date-picker v-model="planDeliveryDate" type="date" placeholder="选择时间" style="margin-left: 6px;"
                          width="150px"></gj-date-picker>
          <div style="text-align: right; margin-right:5px;margin-top: 15px">
            <gj-button size="mini" @click="cancelPopover">取消</gj-button>
            <gj-button type="primary" size="mini" @click="batchPlanDate">确定</gj-button>
          </div>
          <gj-button type="text" slot="reference">批量</gj-button>
        </el-popover>
      </template>
      <template v-slot:header:warehouseName>
        <span style="color: red">*&nbsp;</span>目的仓库
        <el-popover placement="bottom" width="160">
          <div style="font-size: 12px;color:#333333;margin-top: -5px; padding-bottom:10px;">
            <span>目的仓库</span>
          </div>
          <gj-warehouse-select
              :fba="false"
              :active="true"
              v-model="deliveryWarehouse"
              placeholder="请选择">
          </gj-warehouse-select>
          <div style="text-align: right; margin-right:-4px;margin-top: 15px">
            <gj-button size="mini" @click="cancelPopover">取消</gj-button>
            <gj-button type="primary" size="mini" @click="batchWarehouse">确定</gj-button>
          </div>
          <gj-button type="text" slot="reference">批量</gj-button>
        </el-popover>
      </template>
      <template v-slot:header:planQuantityHeader>
        <span style="color: red">*&nbsp;</span>计划采购量
      </template>
      <template v-slot:sku="{row}">
        <div>
          <gj-tooltip class="value" :text-line="1" :content="row.name">
            {{ row.name | defaultShow }}
          </gj-tooltip>
        </div>
        <div>{{ row.sku | defaultShow }}</div>
      </template>
      <template v-slot:urgent="{index}">
        <el-form-item class="gj-table-item">
          <gj-switch
              v-model="form.items[index].urgent"
              active-text="是"
              inactive-text="否"
              active-color="#3168F0"
              inactive-color="#CBCED2"
              size="default"
          ></gj-switch>
        </el-form-item>
      </template>
      <template v-slot:planDeliveryDate="{index}">
        <el-form-item
            :prop="`items.${index}.planDeliveryDate`" class="gj-table-item">
          <gj-date-picker
              v-model="form.items[index].planDeliveryDate"
              width="100%"
              type="date"
          ></gj-date-picker>
        </el-form-item>
      </template>
      <template v-slot:planQuantity="{index}">
        <el-form-item
            :prop="`items.${index}.planQuantity`"
            :rules="[
              { required: true, message: '请输入计划采购量', trigger: ['blur'] }]"
            class="gj-table-item">
          <gj-input
              :ref="`items.${index}.planQuantity`" width="100%"
              v-model="form.items[index].planQuantity" v-number.positive>
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:deliveryWarehouse="{index}">
        <el-form-item
            :prop="`items.${index}.deliveryWarehouse`"
            :rules="[
                { required: true, message: '请选择目的仓库', trigger: ['blur'] }]"
            class="gj-table-item"
        >
          <gj-warehouse-select
              :fba="false"
              :active="true"
              v-model="form.items[index].deliveryWarehouse"
              @input="changeWarehouseSelect($event,`items.${index}.deliveryWarehouse`)"
              :clearable="false"
              width="100%"
              placeholder="请选择">
          </gj-warehouse-select>
        </el-form-item>

      </template>
      <template v-slot:memo="{index}">
        <el-form-item :prop="`items.${index}.memo`" class="gj-table-item">
          <gj-input v-model="form.items[index].memo" width="100%" placeholder="备注">
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:op="{index}">
        <gj-button
            type="text" @click="deleteItem(index)">移除
        </gj-button>
      </template>
      <template #footer>
        <div class="table-footer">
          <span style="margin-right: 20px">{{ lengthTitle }}：{{ form.items.length }}</span>
          <span>总计划采购量：{{ sumPlanQuantity }}</span>
        </div>
      </template>
    </gj-table>
  </el-form>
</template>

<script>
import {OpEnum, ProductEnum} from "@/utils/options";
import AppAddProductModal from "./add-product-modal";
import AppImportProductModal from "./import-product-modal";
import {formDeleteItemMixin, formRuleMixin, opTypeMixin, responseMixin, selectionMixin} from "@/minxins";
import {isMeaningful, unique} from "@/utils/common";
import GjWarehouseSelect from "@/components/select/gj-warehouse-select";


export default {
  name: "app-op-purchase-plan-product",
  mixins: [formRuleMixin, responseMixin, formDeleteItemMixin, opTypeMixin, selectionMixin],
  components: {GjWarehouseSelect},
  props: {
    mountTo: {
      required: false,
    },
    form: {
      required: true
    },
    opType: {
      required: true
    },
    transferOrder: {
      required: true
    },
    cloneDeliveryPlan: {
      required: false,
      default: () => {
        return [];
      }
    },
    lengthTitle: {
      required: true
    },
    offsetHeight: {
      default: 58
    }
  },
  data() {
    return {
      planDeliveryDate: '',
      deliveryWarehouse: null,
      planDataVisible: false,
      warehouseVisible: false,
      columns: [
        {id: 'smallImageUrl', header: '图片', field: 'picture:smallImageUrl', width: '60px', align: 'center'},
        {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '250px', align: 'left'},
        {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', width: '100px', align: 'left'},
        {id: 'urgent', header: '是否加急', field: 'slot:urgent', minWidth: '100px', align: 'center'},
        {
          id: 'planDeliveryDate',
          header: 'slot:planDate', field: 'slot:planDeliveryDate', minWidth: '150px',
          align: 'center'
        },
        {
          id: 'planQuantity',
          header: 'slot:planQuantityHeader',
          field: 'slot:planQuantity',
          minWidth: '150px',
          align: 'center'
        },
        {
          id: 'deliveryWarehouseId',
          header: 'slot:warehouseName', field: 'slot:deliveryWarehouse',
          minWidth: '170px', align: 'center'
        },
        {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '300px', align: 'left'},
        {id: 'op', header: '操作', field: 'slot:op', width: '80px', align: 'center', fixed: 'right'},
      ],
      OpEnum: OpEnum,
      productTypeOption: ProductEnum.typeOption,
    }
  },
  created() {
    this.initColumns();
  },
  computed: {
    sumPlanQuantity() {
      let sum = 0;
      if (this.form.items && this.form.items.length > 0) {
        this.form.items.forEach(item => {
          if (item.planQuantity) sum += Number(item.planQuantity)
        })
      }
      return sum;
    }
  },
  methods: {
    initColumns() {
      if (this.editOpType) {
        this.columns.pop();
        this.columns.unshift({id: 'purchasePlanCode', header: '计划编号', field: 'purchasePlanCode', width: '160px'});
      }
    },
    changeWarehouseSelect(val, validItem) {
      if (val) {
        this.$refs.form.validateField(validItem);
      }
    },
    batchPlanDate() {
      this.form.items.forEach(item => {
        item.planDeliveryDate = this.planDeliveryDate;
      })
      this.cancelPopover();
    },
    //  批量操作 隐藏
    cancelPopover(){
      document.body.click();
    },
    batchWarehouse() {
      this.form.items.forEach(item => {
        item.deliveryWarehouse = this.deliveryWarehouse;
      })
      this.cancelPopover();
    },
    addProduct() {
      this.$gjCreate(AppAddProductModal, {
        mountTo: this.mountTo,
        props: {
          hideSkuList: this.form.items.map(item => item['sku'])
        },
        on: {
          select: (products) => {
            const items = this.form.items.concat(products.map(item => this.mapToItem(item)));
            this.form.items = unique(items, 'id');
          }
        }
      });
    },
    importProduct() {
      this.$gjCreate(AppImportProductModal, {
        mountTo: this.mountTo,
        props: {
          hideSkuList: this.form.items.map(item => item['sku']),
        },
        on: {
          importSuccess: (data) => {
            this.updateItems(data);
          },
          importPartSuccess: (data) => {
            this.updateItems(data);
          }
        }
      })
    },
    deleteProduct(rows) {
      if (rows.length === 0) return false;
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '移除确认',
          content: '确定要移除选中产品?'
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            rows.forEach(item => {
              const find = this.form.items.findIndex(row => item['sku'] === row['sku']);
              if (find !== -1) this.form.items.splice(find, 1)
            })
            modal.$gjDestroy()
          }
        }
      })
    },
    updateItems(data) {
      if (isMeaningful(data)) {
        data.forEach(newItem => {
          if (this.cloneDeliveryPlan.length > 0) {
            const delivery = this.cloneDeliveryPlan.find(item => newItem['sku'] === item['sku']);
            if (delivery) newItem.shipPlanCodeList = delivery.shipPlanCodeList;
          }
          const find = this.form.items.find(oldItem => newItem['sku'] === oldItem['sku']);
          if (find) {
            Object.assign(find, this.mapToItem(newItem));
          } else {
            this.form.items.push(this.mapToItem(newItem));
          }
        });
      }
    },
    mapToItem(item) {
      return {
        ...item,
        urgent: item.urgent || null,
        planDeliveryDate: item.planDeliveryDate || null,
        planQuantity: item.planQuantity || null,
        deliveryWarehouse: item.deliveryWarehouse || item.deliveryWarehouseId || null,
        deliveryWarehouseName: item.deliveryWarehouseName || null,
        memo: item.memo || null
      }
    },
    formValidate() {
      if (this._.isEmpty(this.form.items)) {
        this.$gjMessage.error('请添加产品');
      }
      let formValid = false;
      this.$refs.form.validate((valid, validObj) => {
        formValid = valid;
        if (!valid) {
          const [validKey] = Object.keys(validObj)
          this.$refs[validKey] && this.$refs[validKey].focus && this.$refs[validKey].focus()
        }
      })
      return formValid
      // return this.$gjFormValidate();
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ span.el-switch__label.el-switch__label--left.is-active {
  position: relative;
  left: 45px;
  z-index: 200;
  color: #FFFFFF;
}

/deep/ span.el-switch__label.el-switch__label--right.is-active {
  position: relative;
  z-index: 200;
  color: #FFFFFF;
  left: -45px;
}

/deep/ .gj-table--default td:not(.vxe-footer--column) {
  height: 56px !important
}

/deep/ .el-switch {
  overflow: hidden;

  &.is-checked {
    .el-switch__label--left {
      visibility: hidden;
      position: relative;
      left: -4005px;
    }
  }

  &:not(.is-checked) {
    .el-switch__label--right {
      visibility: hidden;
      position: relative;
      left: -4005px;
    }

  }
}

.table-footer {
  height: 38px;
  background: #F6F8FB;
  text-align: right;
  font-size: 12px;
  font-weight: 600;
  color: #333333;
  line-height: 38px;
  padding-right: 30px;
}
</style>
